import lodash from 'lodash';

export default function sortChoices(
  choices: ChoiceWithQuantity[],
  choiceOrderingMethod: ChoiceOrderingMethod,
) {
  let direction: 'asc' | 'desc';

  if (choiceOrderingMethod === 'cheapest') {
    direction = 'asc';
  } else {
    direction = 'desc';
  }

  return lodash.orderBy(choices, 'baseMoneyPrice', [direction]);
}
